import { useMutation } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import Resources from '../../../helpers/resources';
import { getValueFromUrl } from '../../../helpers/utils';
import { getDifferenceInSeconds } from '../../activity/activity-utils';
import { resetConquestState } from '../../conquest/conquest.actions';

export const useValidate = () => {
  const dispatch = useDispatch();
  const { conquestReducer, assignmentIdReducer, activityReducer } = useSelector(state => state);
  const { startDate, questions } = activityReducer;
  const { answer } = conquestReducer;

  const validate = async () => {
    const res = await Resources.saveQuestionResultQtc
      .post()
      .withBody({
        assignmentId: assignmentIdReducer,
        questionId: questions[0].id,
        studentAnswer: answer,
        locale: getValueFromUrl('locale'),
        productId: 1,
        timeToAnswerSec: getDifferenceInSeconds({
          startDate,
          endDate: new Date()
        })
      })
      .send();

    return res;
  };

  const validatePreview = async () => {
    dispatch(resetConquestState());
    const res = await Resources.validateSingleQuestion
      .post()
      .withBody({
        studentAnswer: answer,
        questionId: getValueFromUrl('singleQuestionId'),
        locale: getValueFromUrl('locale')
      })
      .send();
    const datVal = { ...res.data };
    res.data = {
      needAttention: false,
      nextQuestion: questions[0],
      stepCompleted: 0,
      streak: [-1, -1, -1, -1, -1, -1, -1, datVal.validationResult.isCorrect ? 1 : 0],
      streakAchieved: false,
      totalPoints: 10,
      validation: datVal
    };

    return res;
  };

  return { ...useMutation({
    mutationFn: getValueFromUrl('singleQuestionId') ? validatePreview : validate
  }) };
};
